import {each} from 'lodash';
import SweetAlert from '../vendor/SweetAlert';

export default class CopyToClipboard {

    static init() {
        each(document.querySelectorAll('[data-copy-clipboard]'), (element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                CopyToClipboard.copy(element.dataset.clipboardContent);
            });
        });
    }

    static copy(string, successMessage) {
        const el = document.createElement('textarea');
        el.value = string;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        successMessage = successMessage || app.clipboard_copy_notification;
        SweetAlert.toastSuccess(successMessage);
    }
}
